import type {DisplayType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';

export interface PublishingAsWebpagePanelProps {
  displayType: DisplayType;
  hashedId?: string;
  publishItemType?: PublishingAsWebpageType;
  onTogglePublish?: () => void;
}

export interface PublishingAsWebpageResponse {
  shareableUrl: string;
  isPublishedLink: boolean;
  isUrlDisabled: boolean;
}

export enum PublishingAsWebpageType {
  PUBLISH_EMAIL = 'publishEmail',
  PUBLISH_POSTER = 'publishPoster',
}
